<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-row dense align="center" justify="center"  v-if="!$root.isTouch">
                        <v-col cols="12" :sm="sm" v-for="(v,k) in listSeguros" :key="k">
                            <v-tooltip bottom width="40%">
                                <template v-slot:activator="{ on }">
                                    <v-img :src="v.foto" :id="_.camelCase(v.seguro)"
                                        contain height="300" max-height="300" v-on="on" @click="next(v)">
                                    </v-img>
                                </template>
                                <span v-html="`Seguro de ${v.seguro}`"></span>
                            </v-tooltip>
                        </v-col>
                    </v-row>

                    <v-row dense align="center" justify="center" v-else>
                        <v-col cols="12" :sm="sm" v-for="(v,k) in listSeguros" :key="k">
                            <v-img :src="v.foto" :id="_.camelCase(v.seguro)"
                                contain height="200" max-height="200" @click="next(v)">
                            </v-img>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name:'windowSegurosClienteComponent',
        inject:['setData','setStep'],
        props:{
            listSeguros:{
                type: Array,
                default: () => []
            },
        },
        computed:{
            sm(){
                var n = _.size(this.listSeguros);
                var sm = 3;
                
                if(n > 1 && n < 3 )
                    sm = 6;
                else if(n > 2 && n < 5 )
                    sm = 4;
                else if(n > 4 && n < 7 )
                    sm = 3;

                return sm;
            }
        },
        methods:{
            next(v){
                this.setData('obSearch',{idSeguro:v.idSeguro});
                this.setStep(2);
            }
        }
    }
</script>

<style scoped>
    #vehiculos:hover{
        cursor: pointer;
    }
</style>